const rarities = [
  {
    value: 'UR',
    label: 'UR',
  },
  {
    value: 'SSR',
    label: 'SSR',
  },
  {
    value: 'SR',
    label: 'SR',
  },
  {
    value: 'R',
    label: 'R',
  },
  {
    value: 'N',
    label: 'N',
  },
];

export default rarities;
